export default "__VITE_ASSET__1e7410df__"